'use client';
import useTranslation from '../../../../../packages/ui/src/context/Translation/useTranslation';
import { UnitOfMeasureEnum } from '@enums/recipe-enums';
import { IngredientSummaryProps } from '@repo/ui/src/types/recipes';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';
import SlidingSelect from '@components/recipe/recipe-detail/SlidingSelect';
import IngredientList from '@views/RecipeDetailPage/_IngredientList';

interface Props {
  loading?: boolean;
  servingSizes: Array<{ people: number }>;
  servingSize: number;
  unitOfMeasure: number;
  setUnitOfMeasure: StateSetterFunction<number>;
  ingredientSummary?: IngredientSummaryProps;
  isLoading: boolean;
  className?: string;
  shoppableIngredients: Array<any>;
}

const RecipeIngredients = ({
  servingSizes,
  servingSize,
  unitOfMeasure,
  setUnitOfMeasure,
  ingredientSummary,
  isLoading,
  className,
}: Props) => {
  const { t } = useTranslation();
  if (!servingSizes?.length || !ingredientSummary) return null;

  return (
    <div className={className}>
      {(isLoading || !!servingSize) && (
        <>
          <h6 id="serving-people" className="tra-text-web-heading-6 mb-7">
            {t('recipeContent.yieldsLabel', undefined, { default: 'Yields' })}:{' '}
            <span>{servingSize}</span>{' '}
            {t('recipeContent.servingsLabel', undefined, { default: 'Servings' })}
          </h6>
          <hr />
        </>
      )}

      <h4 className="tra-text-web-heading-4 text-left sm:pb-5 mt-8">
        {t('recipeContent.ingredientsLabel', undefined, { default: 'Ingredients' })}
      </h4>

      {ingredientSummary?.groups?.map((group, i) => (
        <IngredientList group={group} unitOfMeasure={unitOfMeasure} key={i} />
      ))}
      {ingredientSummary?.hasMetric && ingredientSummary?.hasImperial && (
        <div className="flex flex-row mt-3">
          <div className="w-full mb-10">
            <h5 className="text-left mb-4 tra-text-web-heading-7 w-full">
              {t('recipeContent.unitsOfMeasurementLabel', undefined, {
                default: 'Units of Measurement',
              })}
              :
            </h5>
            <SlidingSelect
              options={[
                {
                  text: t('unitsOfMeasurement.imperialLabel', undefined, { default: 'Imperial' }),
                  value: UnitOfMeasureEnum.Imperial,
                },
                {
                  text: t('unitsOfMeasurement.metricLabel', undefined, { default: 'Metric' }),
                  value: UnitOfMeasureEnum.Metric,
                },
              ]}
              selectedValue={unitOfMeasure}
              setSelected={(value) => setUnitOfMeasure(value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RecipeIngredients;
